import React, { useState } from "react";

import searchParamsContext from "../searchParamsContext";

export default function StateSearchParamsProvider({ children }) {
  const { Provider } = searchParamsContext;
  const [params, setParams] = useState({});
  return <Provider value={[params, setParams]}>{children}</Provider>;
}
